import { createSlice } from '@reduxjs/toolkit';

import { getItem, storeItem } from '../helpers/store';

const STORAGE_ID = 'main-menu-state';
const SIDEBAR_SECTIONS_EXPANDED_STORAGE_KEY = 'sidebar-sections-state';

/** Which sidebar sections are expanded (open) by default. true = expanded, false = collapsed. */
const DEFAULT_SECTIONS_EXPANDED = {
  lists: true,
  crm: false,
  research: false,
  jobBoard: false,
};

const initialize = () => {
  const width = window.screen.availWidth < window.innerWidth ? window.screen.availWidth : window.innerWidth;

  if (width < 990) {
    return false;
  }

  const stored = getItem(STORAGE_ID);

  if (stored === null) {
    return true;
  }

  return stored === 'true';
};

const getStoredSectionsExpanded = () => {
  const stored = getItem(SIDEBAR_SECTIONS_EXPANDED_STORAGE_KEY);
  if (stored === null || stored === undefined) {
    return { ...DEFAULT_SECTIONS_EXPANDED };
  }
  try {
    const parsed = JSON.parse(stored);
    if (parsed && typeof parsed === 'object') {
      const merged = { ...DEFAULT_SECTIONS_EXPANDED };
      Object.keys(DEFAULT_SECTIONS_EXPANDED).forEach((key) => {
        if (parsed[key] === true || parsed[key] === false) {
          merged[key] = parsed[key];
        }
        // else keep merged[key] from DEFAULT_SECTIONS_EXPANDED (expanded by default)
      });
      return merged;
    }
  } catch (_) {
    // ignore invalid JSON
  }
  return { ...DEFAULT_SECTIONS_EXPANDED };
};

const initialState = {
  isOpen: initialize(),
  sectionsExpanded: getStoredSectionsExpanded(),
};

export const mainMenuSlice = createSlice({
  name: 'mainMenu',
  initialState,
  reducers: {
    toggleMenu: (state) => {
      const newState = !state.isOpen;
      // eslint-disable-next-line no-param-reassign
      state.isOpen = newState;
      storeItem(STORAGE_ID, newState);
    },
    toggleSection: (state, action) => {
      const sectionKey = action.payload;
      if (state.sectionsExpanded && Object.prototype.hasOwnProperty.call(state.sectionsExpanded, sectionKey)) {
        // eslint-disable-next-line no-param-reassign
        state.sectionsExpanded[sectionKey] = !state.sectionsExpanded[sectionKey];
        storeItem(SIDEBAR_SECTIONS_EXPANDED_STORAGE_KEY, JSON.stringify(state.sectionsExpanded));
      }
    },
  },
});

export const { toggleMenu, toggleSection } = mainMenuSlice.actions;

export default mainMenuSlice.reducer;
